import React from 'react'

import styles from './TaskStatus.module.sass'

const TaskStatus = (props) => {
	const { className, tiny, status } = props
	return (
		<svg
			className={`${styles['root'] || ''} ${className || ''} ${
				styles[status] || ''
			}`}
			viewBox='0 0 24 24'
			width='24'
			height='24'
		>
			{!tiny && (
				<circle
					className={styles['shadow-circle']}
					cx='12'
					cy='12'
					r='6'
				/>
			)}
			<circle
				className={styles['circle']}
				cx='12'
				cy='12'
				r='3'
				strokeWidth='1'
			/>
		</svg>
	)
}

export default TaskStatus
